import { useState, useMemo } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import ICoverageArea from "../interfaces/ICoverageArea";
import { createCoverageAreaAction, deleteCoverageAreaAction, fetchMyCoverageAreasAction, updateCoverageAreaAction } from "../actions/coverage.action";

export const useCoverageLogic = () => {
  const queryClient = useQueryClient();
  const [search, setSearch] = useState("");
  const [selectedId, setSelectedId] = useState<number | null>(null);

  // Obtener áreas del servidor
  const { data: areas = [], isLoading } = useQuery<ICoverageArea[]>({
    queryKey: ["coverage-areas"],
    queryFn: fetchMyCoverageAreasAction,
  });

  const invalidate = () => queryClient.invalidateQueries({ queryKey: ["coverage-areas"] });

  // Mutaciones
  const addMutation = useMutation({
    mutationFn: createCoverageAreaAction,
    onSuccess: invalidate,
  });

  const updateMutation = useMutation({
    mutationFn: (dto: Partial<ICoverageArea>) => updateCoverageAreaAction(dto),
    onSuccess: invalidate,
  });

  const deleteMutation = useMutation({
    mutationFn: deleteCoverageAreaAction,
    onSuccess: invalidate,
  });

  // Lógica de filtrado y mapa
  const filteredAreas = useMemo(() => {
    return areas.filter((a) => a.name.toLowerCase().includes(search.toLowerCase()));
  }, [areas, search]);

  const mapCenter = useMemo(() => {
    const selected = areas.find((a) => a.id === selectedId) || areas[0];
    return selected ? { lat: selected.latitude, lng: selected.longitude } : { lat: 37.7749, lng: -122.4194 };
  }, [areas, selectedId]);

  return {
    areas,
    filteredAreas,
    isLoading,
    search,
    setSearch,
    selectedId,
    setSelectedId,
    mapCenter,
    handleAdd: addMutation.mutateAsync,
    handleUpdate: (dto: Partial<ICoverageArea>) => updateMutation.mutateAsync(dto),
    handleDelete: deleteMutation.mutateAsync,
  };
};
